import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getCropDetail, addCrop, getCrops } from '../../../actions/cropsActions'
import FormCrop from '../../admin/crops/FormCrop'
import Swal from 'sweetalert2'

export default function CropInsert() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {crop, crops} = useSelector(state=>state.crops)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, description} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleAdd = async(e) => {
        e.preventDefault()

        dispatch(addCrop(name, description))
        setFormState({
            name: '',
            description: ''
        })
        
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('crops.add')
        })
    }

    useEffect(()=>{
        dispatch(getCropDetail(id))
        dispatch(getCrops())
    }, [dispatch,id])

    useEffect(() => {
        if (crop) {
            setFormState({
                name: '',
                description: ''
            })
        }
    }, [crop, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/crops`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('crops.volver')}
                    </Button>
                </Row>
                <h1>{t('crops.add')}</h1>
                <FormCrop submit={handleAdd} isNew={true} inputChange={handleInputChange} state={formState} crops={crops}></FormCrop>
            </Row>
        </Container>
    )
}
